const Home = () => {
    return (
        <div className="HomepageContent">
            <div className="h2">
            <h2>Homepage</h2>
            </div>
            
            <h3>This is a blogging website. You can only type with String, and you can talk about anything you want!(As long as it's appropriate).</h3>
            <br></br>
            <h3>First Create a Topic, and then share your experiences!!</h3>
            <br></br>
            <h3>*This website is specifically targetted towards high school and college students. </h3>
        </div>
    );
}
 
export default Home;